import React from 'react';
import PropTypes from 'prop-types';

import BaseModal from '@/components/molecules/modals/BaseModal';

import { HelpModalContent, HelpButton } from './styles';

const HelpSupportModal = ({ open, onClose, onSelectITSupport, onSelectTechnicalSupport }) => {
    const handleITSupport = () => {
        onSelectITSupport();
        onClose();
    };

    const handleTechnicalSupport = () => {
        onSelectTechnicalSupport();
        onClose();
    };

    return (
        <BaseModal title="Como podemos ajudar?" open={open} handleClose={onClose} maxWidth="sm">
            <HelpModalContent>
                <HelpButton onClick={handleITSupport}>
                    <h3>Suporte Técnico - TI</h3>
                    <p>Problemas de acesso, bugs, erros no sistema, falhas técnicas ou questões relacionadas à plataforma</p>
                </HelpButton>

                <HelpButton onClick={handleTechnicalSupport}>
                    <h3>Consultoria Técnica</h3>
                    <p>Dúvidas sobre consultoria, interpretação de dados ou orientações</p>
                </HelpButton>
            </HelpModalContent>
        </BaseModal>
    );
};

HelpSupportModal.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    onSelectITSupport: PropTypes.func.isRequired,
    onSelectTechnicalSupport: PropTypes.func.isRequired
};

export default HelpSupportModal;
